<template>
  <summary-section
    v-if="userSocialSites.length > 0 || userIsOnTheirOwnProfile"
    heading="Social"
    data-test-id="profile-social-summary-section"
  >
    <template v-slot:actions>
      <router-link
        v-if="userIsOnTheirOwnProfile"
        to="/profile/edit#social-sites"
        class="summary-section__action-link"
        data-test-id="profile-social-summary-section-link"
      >
        Edit
      </router-link>
    </template>
    <div class="social-sites-list">
      <loading-spinner v-if="loading !== 0" />
      <ul v-else-if="userSocialSites.length" class="list-reset">
        <li v-for="handle in userSocialSites" :key="handle.id">
          <icon-component
            v-if="Object.keys(types).includes(handle.type.toUpperCase())"
            :name="handle.type.toLowerCase()"
            class="social-sites-list__icon"
          />
          <span v-else class="social-sites-list__icon-placeholder" />
          <a
            class="social-sites-list__link"
            :href="urlForHandle(handle)"
            target="_blank"
            rel="noopener noreferrer nofollow"
            data-test-id="social-sites-list-item-link"
          >
            {{ prefixForHandle(handle) }}{{ handle.url }}
          </a>
        </li>
      </ul>
      <p
        v-else
        class="social-sites-list__placeholder"
      >
        Where can we find you?
      </p>
    </div>
  </summary-section>
</template>

<script>
import { mapGetters } from 'vuex';
import SummarySection from '@/components/User/Summary/SummarySection.vue';
import { USER_SOCIAL_SITES_QUERY } from '@/graphql/queries/user-queries';

export default {
  name: 'SocialSitesList',
  components: {
    SummarySection,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    limit: {
      type: Number,
      default: 0,
    },
    linkHref: {
      type: String,
      default: '/profile/awards',
    },
  },
  data() {
    return {
      loading: 0,
      userSocialSites: [],
      types: {
        BLOG: { prefix: 'https://' },
        FACEBOOK: { prefix: '@', host: 'www.facebook.com/' },
        INSTAGRAM: { prefix: '@', host: 'www.instagram.com/' },
        LINKEDIN: { prefix: 'www.linkedin.com/in/', host: 'www.linkedin.com/in/' },
        PINTEREST: { prefix: '@', host: 'www.pinterest.com/' },
        PODCAST: { prefix: 'https://' },
        TIKTOK: { prefix: '@', host: 'www.tiktok.com/@' },
        TWITTER: { prefix: '@', host: 'twitter.com/' },
        WEBSITE: { prefix: 'https://' },
        YOUTUBE: { prefix: '@', host: 'www.youtube.com/@' },
      },
    };
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    userIsOnTheirOwnProfile() {
      return this.user.id === this.currentUser.id;
    },
  },
  methods: {
    prefixForHandle(handle) {
      return this.types[handle.type.toUpperCase()]?.prefix || '';
    },
    urlForHandle(handle) {
      const host = this.types[handle.type.toUpperCase()]?.host || '';
      return `https://${host}${handle.url}`;
    },
  },
  apollo: {
    userSocialSites: {
      query: USER_SOCIAL_SITES_QUERY,
      variables() {
        return {
          userId: this.user.id,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_social-sites-list';
</style>
